import { translate } from '@repo/phrase';
import { Heading, Paragraph } from '@repo/ui/typography';

import styles from './styles.module.scss';

interface Props {
    message?: string;
}
export const NoResult = ({ message }: Props) => {
    return (
        <div className={styles.page_container} data-testid="no-result">
            <div className={styles.message_container}>
                <Heading headingSize="xs"> {message ?? translate('no_result_message')}</Heading>
                <Paragraph>{translate('no_result_sub_text')}</Paragraph>
            </div>
        </div>
    );
};
